<template>
  <div
    v-if="fields"
    class="py-12 text-center"
    :class="[ backgroundColorClass, { 'white--text': fields.backgroundColor !== 'white' }]"
  >
    <p class="h4 d-inline">
      Talk to a Medicare Specialist by calling
      <a
        v-if="$vuetify.breakpoint.xs"
        :href="fields.phone | phoneHref"
        class="white--text mr-1"
        @click="track()"
      >
        {{ fields.phone }}
      </a>
      <span class="mr-1" v-else>{{ fields.phone }}</span>
      <a
        v-if="$vuetify.breakpoint.xs"
        :href="'tel:'+siteConfig.utilityNavContactPhoneTty"
        class="white--text ml-1"
      >
        TTY: {{ siteConfig.utilityNavContactPhoneTty }}
      </a>
      <span class="ml-1" v-else>TTY: {{ siteConfig.utilityNavContactPhoneTty }}</span>
    </p>
    <br>
    <p class="h4 d-inline">
      {{ fields.availability }}
    </p>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import PixelTracker from '@/components/base/pixel-tracker'

export default {
  name: 'ContactBanner',
  props: {
    fields: {
      type: Object,
      default: null
    }
  },
  computed: {
    ...mapState('site', ['siteConfig', 'configAssets']),
    backgroundColorClass () {
      switch (this.fields.backgroundColor) {
      case 'blue':
        return 'primary'
      case 'green':
        return 'accent'
      case 'white':
        return 'white'
      default:
        return 'primary'
      }
    }
  },
  methods: {
    track () {
      this.siteConfig.careNetworkName.indexOf('Vermont') === -1 ? PixelTracker.track('601117795', 'NNqbCJeDhtwBEOOo0Z4C') : PixelTracker.track('608189871', '_yVMCP2wqNkBEK_7gKIC')
    }
  }
}
</script>
